// Alternating Content
(function () {
	'use strict';

	// Defer iframe loading until the modal opens: players booted inside a
	// hidden modal measure 0x0 and pick their lowest-res poster. Unloading
	// on close also stops playback.
	function initVideoModals() {
		document.querySelectorAll('.alternating-content-modal').forEach(function (modal) {
			modal.querySelectorAll('iframe').forEach(function (iframe) {
				iframe.dataset.src = iframe.getAttribute('src');
				iframe.removeAttribute('src');
			});

			modal.addEventListener('shown.bs.modal', function () {
				modal.querySelectorAll('iframe').forEach(function (iframe) {
					if (!iframe.getAttribute('src')) {
						iframe.setAttribute('src', iframe.dataset.src);
					}
				});
			});

			modal.addEventListener('hidden.bs.modal', function () {
				modal.querySelectorAll('iframe').forEach(function (iframe) {
					iframe.removeAttribute('src');
				});
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initVideoModals);
	} else {
		initVideoModals();
	}
})();
